import { createSlice } from "@reduxjs/toolkit";

const crmSlice = createSlice({
    name: 'crm',
    initialState: {},
    reducers: {
        setCrm: (state, action) => {
            const crm = action.payload
            state.crm = crm
        }
    }
})

export const { setCrm } = crmSlice.actions

export default crmSlice.reducer

export const selectCrm = (state) => state?.crm?.crm